<template>
  <div class="page__wrap">
    <Breadcrumb :config="breadcrumb" />
    <div class="frequently-asked_questions__wrap">
      <div class="m-faq__help-block" v-if="false">
        <h1 class="sr-only">经常问的问题</h1>
        <div class="content-asset">
          <p class="ms-row center-xs c-contact-block">
            <span class="c-contact-block__title col-xs-12 col-sm-6 center-xs end-sm">需要帮忙 ？</span>
            <span class="c-contact-block__phone col-xs-12 col-sm-6 center-xs start-sm hide-for-md">
              <a class="l-footer__contact-phone-link" href="tel:+0-800-74-28-28">0 800 74 28 28</a>
            </span>
            <span class="c-contact-block__phone col-xs-6 start-xs show-for-md">0 800 74 28 28</span>
            <span
              class="c-contact-block__description text--no-margin col-xs-7 col-sm-12 center-xs">周一至周四上午9点至下午6点和周五周五上午9点至下午1点致电客户服务（免费电话）</span>
          </p>
        </div>
      </div>
      <div class="m-faq__list-container">
        <div class="m-faq__heading">
          <IconTitle :config="iconTitle" />
        </div>
        <div class="m-faq__list">
          <template v-for="(item, index) in items">
            <div :class="['m-faq__list-item', 'c-toggler', activeIndex == index ? 'c-toggler--expanded' : '']"
              :key="index" :id="`Q-${index}`">
              <h2>
                <button class="m-faq__list-question c-toggler__title heading-h4 text--left" @click="toggle(index)">{{
      item.title }}</button>
              </h2>
              <section class="m-faq__list-answer c-toggler__content">
                <div class="m-faq__sub-list">
                  <div class="m-faq__sub-list-item" v-for="(innerItem, innerIndex) in item.children"
                    :key="`QA-${index}-${innerIndex}`">
                    <div role="heading" class="m-faq__sub-list-question">{{ innerItem.title }}</div>
                    <p class="m-faq__sub-list-answer text--no-margin" v-for="(subItem, subIndex) in innerItem.children"
                      :key="`QA-${index}-${innerIndex}-${subIndex}`" v-html="htmlify(subItem)"></p>
                  </div>
                </div>
              </section>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import IconTitle from "@/components/IconTitle";

export default {
  name: "FrequentlyAskedQuestions",
  components: { Breadcrumb, IconTitle },
  data() {
    return {
      breadcrumb: {
        items: [{ text: "常见问题", href: "" }]
      },
      iconTitle: { title: "您的问题/我们的答案" },
      items: [
        {
          title: "1 联系我们",
          children: [
            {
              title: "1.1 想咨询更多推荐产品或其他问题，联系我们：",
              children: [
                "1.在线客服：工作时间：周一至周五10:00-22:00（除国定节假日）。我们的在线美容顾问会回答您关于产品及使用方法的问题。",
                "2.面对面咨询：我们的专柜有专业美容顾问恭候您的到来。点击官网“店铺导航”，选择您所在的城市，查找离您最近的专柜。"
              ]
            }
          ]
        },
        {
          title: "2 本网站使用方法",
          children: [
            {
              title: "2.1 如果忘记密码，该如何重新登录账号？",
              children: [
                "如果您忘记密码，请点击页面上的“忘记密码？”按钮，输入您的手机号码，您将收到一个验证码，输入验证码后你可以重设登录密码，保护您的个人信息安全。"
              ]
            },
            {
              title: "2.2 如何修改配送地址？",
              children: [
                "您可在“我的账户”下的“我的地址簿”修改配送地址。"
              ]
            },
            {
              title: "2.3 如何在线购买？",
              children: [
                `在希思黎网站购物非常简单、快速、安全。

                第一步：首先选择您想购买的产品，选择购买数量（每款产品最多选择6件）。在下拉框中选择型号、颜色、尺寸。
                第二步：点击“立即购买”或加入购物车后在购物车页面选择商品，确认想购买的产品并提交订单。
                第三步：当产品已被放入购物车，选择您喜欢的体验装，之后您需要登录或创建新账号以最终确认订单。`
              ]
            },
            {
              title: "2.4 如何在线查找产品？",
              children: [
                `您可在搜索栏中输入产品名称，来快捷搜索产品。
                所有的希思黎产品都能在线购买，如果某一产品暂时缺货，您可先选择该产品，但不能立刻放入购物车，直到产品重新有库存后才能购买。`
              ]
            },
            {
              title: "2.5 如何使用电子礼券/优惠码？",
              children: [
                `您可在我的购物车页面中选择电子礼券或输入电子礼券优惠码，并点击“应用”确认。点击“不使用优惠”则可取消使用。每个订单仅限使用一张电子礼券/优惠码。`
              ]
            },
            {
              title: "2.6 如何追踪订单？",
              children: [
                `您能在“我的账户”下“我的订单”中查看到关于订单的所有详情，包括订单状态、购买产品清单、总价格、账单及送货地址、送货方式。

                您的订单状态将归于以下几类：
                待支付：您的订单尚未支付成功
                待收货：您的订单已确认，我们将尽快发货
                已完成：您的订单已经签收
                售后处理：您的订单在退款/退货处理中`
              ]
            },
            {
              title: "2.7 如何更改订单内容？",
              children: [
                `如果确认提交订单后您想更改订单内容，请联系官网在线客服。`
              ]
            },
            {
              title: "2.8 如何选择或编辑您喜爱的产品？",
              children: [
                `您可以点击“加入我喜爱的产品”。`
              ]
            }
          ]
        },
        {
          title: "3 配送",
          children: [
            {
              title: "3.1 有哪几种送货选择，费用分别是多少？",
              children: [
                "本网站所有订单都可享受免运费服务。中国大陆的订单将会通过顺丰速递为您送达。（特殊要求及新疆，西藏，海南地区除外）。"
              ]
            },
            {
              title: "3.2 能跨国发送产品吗？",
              children: [
                "我们无法将产品送往中国大陆以外的地址，也无法送往诸如邮政信箱之类的虚拟地址。"
              ]
            }
          ]
        },
        {
          title: "4 支付",
          children: [
            {
              title: "4.1 接受哪些付款方式？",
              children: [
                "我们提供三种安全的支付方案：银联电子支付、支付宝付款、支付宝花呗付款、微信付款、货到付款。"
              ]
            },
            {
              title: "4.2 如果付款不成功，我该怎么办？",
              children: [
                "如果在线支付不成功，请联系您的银行。关于支付的其他问题，您也可以咨询在线客服。"
              ]
            }
          ]
        },
        {
          title: "5 退货及退款",
          children: [
            {
              title: "5.1 我该如何退货？",
              children: [
                `签收之日起的7天内可无条件退换货。为了节约您的时间，请您先联系在线客服，告知客服服务专员您所遇到的问题和购买产品的订单号，然后根据我们客户服务代表的指示和进行退换货；（在希思黎未受理您的退货申请时，请不要把货品寄回。）
                请注意，所有退回的产品必须是完整并状态良好，用原包装退回。

                如果退货订单中有免费赠品或打折套装，则您必须将这些也连同退货产品一同退回。

                请您保留退货时的发货凭证。万一我们没有收到您的退货时，请您出示。

                退货产品必须有良好完整的状态，消费者有责任保存好产品。`
              ]
            },
          ]
        },
        {
          title: "6 发票",
          children: [
            {
              title: "6.1 我要如何获得发票？",
              children: [
                `为了使您能够体验到更好更优质的服务体验，Sisley为在官网购买产品的顾客提供电子发票。

                您可以在订单结算页选择增值税普通电子发票申请，发票将在订单签收的15个工作日之后发送至邮箱，也可在“我的订单-已支付”中重新发送。

                请您耐心等待，我们非常感谢您的理解与支持。`
              ]
            }
          ]
        },
        {
          title: "7 希思黎产品",
          children: [
            {
              title: "7.1 我要如何得到希思黎体验装？",
              children: [
                `只要您在www.sisley.com.cn官方商城购买正装产品，即有机会获得您所喜爱的体验装。`
              ]
            },
            {
              title: "7.2 希思黎产品中都有哪些成分？",
              children: [
                `您可通过以下方式来获取关于希思黎产品成分的信息：

                1. 在线客服：工作时间： 周一至周五10:00-22:00（除国定节假日）。我们的在线美容顾问会回答您关于产品及使用方法的问题。
                2. 面对面咨询：我们的专柜有专业美容顾问恭候您的到来。点击官网“店铺导航”，选择您所在的城市，查找离您最近的专柜。`
              ]
            },
            {
              title: "7.3 孕期是否可以使用希思黎产品？",
              children: [
                `希思黎产品选用天然植物精粹以及植物精油，温和安全。但怀孕是非常特殊的生理阶段，怀孕阶段使用产品请先咨询您的医生。`
              ]
            },
            {
              title: "7.4 保质期",
              children: [
                `Sisley希思黎提供的每一款产品，都符合Sisley希思黎品牌所要求的上乘品质以及卓越功效。每个产品的保质期都会在中文标签中有明确标识，使用时请以中文标签为准。`
              ]
            },
            {
              title: "7.5 公司合作关系",
              children: [
                `关于公司合作关系，您可以通过官网在线客服了解更多详情`
              ]
            },
            {
              title: "7.6 工作机会",
              children: [
                `如果您对希思黎的工作机会或实习机会感兴趣，可直接将简历发至公司人力资源部：cn.hr@sisley.fr`
              ]
            }
          ]
        },
      ],
      activeIndex: -1
    };
  },
  created() {
    let anchor = String(this.$route.hash || "").replace("#Q-", "");
    if (!isNaN(anchor)) {
      this.activeIndex = parseInt(anchor) + 1;
    }
  },
  methods: {
    toggle(idx) {
      this.activeIndex = this.activeIndex != idx ? idx : -1;
    },
    htmlify(str) {
      return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
    }
  }
}
</script>

<style lang="scss" scoped>
.frequently-asked_questions__wrap {
  padding: 0 1.125rem;
}

.c-contact-block__phone,
.c-contact-block__title {
  font-size: 1.5625rem;
  color: #000;
}

.c-contact-block__phone {
  font-family: HelveticaNeueLTW05-35Thin, arial, sans-serif;
}

.m-faq__list-container {
  padding-bottom: 3.125rem;
}

.m-faq__heading {
  position: relative;
  margin: 3.5625rem 0 -1.25rem;
}

.m-faq__list {
  padding-top: 1.875rem;
}

/*  */
.c-toggler__title {
  display: block;
  margin-bottom: 0;
  padding: .9375rem 0;
  cursor: pointer;
  position: relative;
  border-top: .0625rem solid #dfdfdf;
  border-bottom: .0625rem solid #dfdfdf;
}

.c-toggler__title:after {
  content: "";
  width: .9375rem;
  height: .5rem;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%) translateY(-.5px);
  background: url(../assets/imgs/icons/arrow-big.svg) no-repeat;
  background-size: contain;
}

.m-faq__list-question {
  width: 100%;
  border-top: none;
  padding: 2rem 1.75rem 2rem 0;
}

.c-toggler__content {
  display: none;
}

.m-faq__sub-list {
  padding-left: 1.25rem;
}

.m-faq__sub-list-item {
  padding-bottom: 1.25rem;
}

.m-faq__sub-list-question {
  color: #000;
  padding-bottom: .5rem;
}

.m-faq__sub-list-answer {
  padding-left: 1.375rem;
}

/*  */
.m-faq__list-item.c-toggler--expanded {
  padding-bottom: .75rem;
  border-bottom: .0625rem solid #cacaca;
}

.m-faq__list-item.c-toggler--expanded .m-faq__list-question {
  padding-bottom: 1.25rem;
  border-bottom: none;
}

.c-toggler--expanded .c-toggler__title:after {
  transform: translateY(-50%) translateY(-.5px) rotate(180deg);
}

.c-toggler--expanded .c-toggler__content {
  display: inherit;
}

@media screen and (min-width: 48em) {
  .frequently-asked_questions__wrap {
    padding: 0 3.875rem;
  }

  .m-faq__list-container {
    padding-bottom: 6.25rem;
  }

  .m-faq__list {
    padding-top: 3.125rem;
  }

  .m-faq__list-question {
    padding: 2.125rem 1.75rem 2.125rem 0;
  }

  .m-faq__sub-list {
    padding-left: 3.4375rem;
  }
}

@media screen and (min-width: 64em) {
  .breadcrumb {
    padding: 0 1.875rem;
  }

  .frequently-asked_questions__wrap {
    padding: 0 1.875rem;
  }

  .m-faq__list {
    max-width: 49.6875rem;
    margin: 0 auto;
  }

  .m-faq__sub-list {
    padding-left: 6.25rem;
  }
}

@media screen and (min-width: 75em) {
  .frequently-asked_questions__wrap {
    padding: 0;
  }

  .m-faq__heading {
    margin-top: 6.25rem;
  }
}
</style>